import React from "react";
import MagazynListPage from "./MagazynListPage";
import { HANDLING } from "./magazynListConfigs";

// Archiwum Handling (Magazyn Warszawa) - wspolny widok listy z konfiguracja tej listy.
const Handling = () => <MagazynListPage config={HANDLING} />;

export default Handling;
